import { Expose, Type } from 'class-transformer';
import { Model } from '@shared/models/model';
import { ShipmentStatus } from '@shared-features/enums/shipments.enum';

export class ActiveShipment extends Model {
  @Expose() id: number;
  @Expose() name: string;
  @Expose() fromCityName: string;
  @Expose() toCityName: string;
  @Expose() status: ShipmentStatus;
  @Expose() deliveryDate: number;
}

export class ActiveShipments extends Model {
  @Expose() totalActive: number;
  @Expose() @Type(() => ActiveShipment) shipments: ActiveShipment[];
}
